import { FridgeTopIcon } from './FridgeTopIcon';

/**
 * author: Simran
 * id 3D6FCDAF-F7F8-42C2-87C6-6DF36EB8C935
 * name fridge-top
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-top.svg
 * tags
 * - Home Automation 
 */
export const RefrigeratorTopIcon = FridgeTopIcon;
export default RefrigeratorTopIcon